import Cookies from 'js-cookie'
const isPord = !window.location.host.includes('test')
const appkey = isPord ? 'Bko8YZXpZbMA48CYgxWH6f' : 'GuvRqUiQg75NyEDpEerr8V'
let accountClientSdk = null
function loadJS() {
  return new Promise((resolve, reject) => {
    // 加载SDK
    if (window.account_web_sdk) resolve()
    var script = document.createElement('script')
    script.src = window.location.host.includes('test') ||  window.location.host.includes('localhost')
      ? 'https://uc-heytap-web-test.wanyol.com/packages/account_web_sdk/index.umd.js'
      : 'https://id.heytap.com/packages/account_web_sdk/index.umd.js'
    //IE
    if (script.readyState) {
      script.onreadystatechange = function() {
        if (script.readyState == 'loaded' || script.readyState == 'complete') {
          script.onreadystatechange = null
          resolve()
        }
      }
    } else {
      //其他浏览器
      script.onload = () => resolve()
    }
    document.head.appendChild(script)
  })
}
async function sdkInit(callback = () => {}) {
  await loadJS()
  if (accountClientSdk) return callback()
  accountClientSdk = new window.account_web_sdk({
    brand: window.account_web_sdk.supportBrand.realme,
    environment: isPord ? 'prod' : 'test'
  })
  callback();
}
export function login() {
  sdkInit(loginPage)
}
function loginPage() {
  const url = new URL(window.location.href)
  url.searchParams.delete('code')
  Cookies.set('callbackUrlLogin', url.toString())
  accountClientSdk.loginPage({
    bizAppKey: appkey,
    callbackUrl: url.toString(),
    enablePKCEMode: true
  })
}
export function logout() {
  Object.keys(Cookies.get()).forEach(cookie => Cookies.remove(cookie));
  sdkInit(() =>
    accountClientSdk.logout({
      bizAppKey: appkey,
      callbackUrl: window.location.origin,
      enablePKCEMode: true
    })
  )
}
export default {
  login,
  logout,
  sdkInit,
}